<template>
  <div>
    <div class="kt-login-v2__title">
      <h3>Tweestapsverificatie (2FA)</h3>
    </div>

    <form
      class="kt-login-v2__form kt-form pt-3"
      @submit.prevent
    >
      <input
        type="hidden"
        name="_token"
        :value="getMeta('csrf-token')"
      >

      <div class="d-flex">
        <div class="p-2">
          <div class="kt-login-v2__title d-flex align-items-start">
            <h5>Verificatiecode ophalen</h5>
          </div>

          <p>
            Scan de onderstaande afbeelding met de Google Authenticator app om de verificatiecode op te halen.
          </p>

          <div class="flex justify-content-center align-items-center pt-2">
            <div
              v-if="qrCode"
              class="qr-code-container"
              v-html="qrCode"
            />
          </div>
        </div>

        <div style="width: 60%; padding: 1rem;">
          <div class="kt-login-v2__title d-flex align-items-start">
            <h5>Verificatiecode invoeren</h5>
          </div>

          <span>
            Voer de verificatiecode in die Google Authenticator heeft gegenereerd.
          </span>

          <div
            v-if="authCodeInvalid"
            class="alert alert-bold alert-solid-danger alert-dismissible pt-2"
            role="alert"
          >
            <div class="alert-text">
              De ingevoerde verificatiecode is ongeldig.
            </div>
          </div>

          <div class="form-group">
            <input-text
              id="code"
              v-model="authCode"
              type="text"
              name="code"
              title="Authenticator Code"
              class="form-control"
              placeholder=""
              required
              autocomplete="false"
              inputmode="numeric"
              pattern="[0-9]*"
            />
          </div>
        </div>
      </div>

      <div class="kt-login-v2__actions mt-4 justify-content-end">
        <button
          type="submit"
          class="btn btn--primary"
          @click="submit"
        >
          <span>Configuratie voltooien</span>
        </button>
      </div>
    </form>
  </div>
</template>

<script setup lang="ts">
import { useAuthStore } from '@/stores/auth'
import { storeToRefs } from 'pinia'
import { onBeforeMount } from 'vue'
import InputText from '@/components/input/InputText.vue'
import { getMeta } from '@/helpers/general'

const authStore = useAuthStore()

const {
  qrCode,
  userCompletedTwoFactorAuth,
  authCode,
  authCodeInvalid
} = storeToRefs(authStore)

onBeforeMount(async () => {
  await authStore.enableTwoFactorAuth()

  await authStore.fetchQrCode()
})

const submit = async () => {
  if (!authCode.value) return

  authCodeInvalid.value = false

  await authStore.confirmTwoFactorChallenge()
    .then(() => {
      userCompletedTwoFactorAuth.value = true
    })
    .catch((e) => {
      console.error(e)

      if (e?.response?.status === 422) {
        authCodeInvalid.value = true
      }
    })

  if (userCompletedTwoFactorAuth.value) {
    // redirects to the desired page when user is authenticated
    return window.location.href = '/'
  }
}
</script>

<style scoped lang="scss">
::v-deep(svg) {
  width: 100%;
  height: 100%;
}

.qr-code-container {
  width: 220px;
  height: 220px;
}
</style>

